import React, { useCallback, useEffect, useState } from "react";
import {
  fetchTransactions
} from "../../../controller/c_events.js";
import { getCurrencySign, formatAmount } from "../../../controller/helper.js";

export default function TransactionListTable() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  // -----------------------------
  // Data
  // -----------------------------
  const loadtransactions = useCallback(async () => {
    try {
      const evts = await fetchTransactions();
      setEvents(evts || []);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    setLoading(true);
    loadtransactions();

    const id = setInterval(loadtransactions, 10000);
    return () => clearInterval(id);
  }, [loadtransactions]);

  const pm=(pmv)=>{
    switch(pmv){
      case "momo_pay":
        return "Mobile Money";
      case "card_pay":
        return "Card Payment";
      case "bank_pay":
        return "Bank Transfer";
      default:
        return pmv || "";
    }
  }

  // -----------------------------
  // UI
  // -----------------------------
  return (
    <div className="card admin-card">
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-dark table-hover align-middle">
            <thead>
              <tr>
                <th>Fullname</th>
                <th>Amount</th>
                <th>Payment Mode</th>
                <th>Payment Status</th>
                <th className="text-end">Actions</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={6} className="text-center text-white-50 py-4">
                    Loading events...
                  </td>
                </tr>
              ) : events.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center text-white-50 py-4">
                    No events added yet. Click <b>New Event</b> to create one.
                  </td>
                </tr>
              ) : (
                events.map((evt) => (
                  <React.Fragment key={evt.transactionid}>
                    <tr>
                      <td>
                        <div className="fw-bold"> {evt.fullname}</div>
                        <div> {evt.eventtitle || ""}</div>
                      </td>

                      <td className="small">
                        <div>
                          
                          {getCurrencySign(evt.usercountry)} {formatAmount(evt.amount) || ""}
                        </div>
                        {/* <div>
                          <span className="text-white-50">Time:</span>{" "}
                          {evt.event_timeduration || "—"}
                        </div> */}
                      </td>

                      <td>{pm(evt.paymentmode) || ""}</td>


                      <td><div className={"status-badge " + (evt.status === "confirmed" ? "badge-success" : "badge-failed")}>
                        {evt.status.toUpperCase() || ""}
                      </div></td>

                      <td className="text-end">
                        <div className="btn-group">
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
}
